import { render, staticRenderFns } from "./dept.vue?vue&type=template&id=99f46ab6&scoped=true"
import script from "./dept.vue?vue&type=script&lang=js"
export * from "./dept.vue?vue&type=script&lang=js"
import style0 from "./dept.vue?vue&type=style&index=0&id=99f46ab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f46ab6",
  null
  
)

export default component.exports